module.exports = __webpack_public_path__ + "static/media/channel-bank.8f630ae3.svg";